
const NetteShowFormErrorsFunction = Nette.showFormErrors;
let formValidationArray = [];

class InputValidation {

    constructor(formId = null) {

        this.formId = formId;
        this.errors = [];

        const t = this;        
        if(t.formId != null) 
        {
            $(`#${t.formId}`).on('submit', function(e) 
            {
                if(!t.validateForm(this)) { e.preventDefault(); }
            })
            $(`#${t.formId} .validate-form`).on('click', function(e) 
            {
                if(!t.validateForm($(`#${t.formId}`)[0])) { e.preventDefault(); }
            })
        }        
    }

    validateForm(form) 
    {
        $('.form-errors').hide();

        this.showNetteFormErrors(this.formId);
        Nette.validateForm(form);
    
        if(Nette.formErrors.length > 0) {
            return false;
        }

        return true;
    }


    showNetteFormErrors(formId) {

        const t = this;        
        Nette.showFormErrors = function(form, errors) {
            let messages = [];
    
            for (let i = 0; i < errors.length; i++) {
                const elem = errors[i].element;
                const message = errors[i].message;

                if (messages.indexOf(message) < 0 && $(elem).is(":visible")) {
                    t.invalidateInput(elem, message, formId);
                    
                    const error = {'elem': elem, 'message': message};
                    let addError = true;
                    t.errors.forEach((value, index) => {
                        if(value.message === message) { addError = false; };
                    });

                    if(addError) { t.errors.push(error); }

                    return false;
                }
            }
        };
    }




    invalidateInput(input, message, formId) {
        
        const t = this;

        if($(input).hasClass('red')) { $(input).focus(); return; };
        
        $('input.red').removeClass('red');
        $(input).addClass('red')
        $(input).focus();
      
        
        const validationGroup = $(input).closest('.validation-group');

        const errorBoxSelector = '.form-error-box .message';

        let errorMessage = $(errorBoxSelector, $(`#${formId}`));
        if(validationGroup.length > 0) {
            errorMessage = $(errorBoxSelector, validationGroup);
        }

        $(errorBoxSelector).hide();
        $(errorBoxSelector).text('');

        if(errorMessage.length > 0) 
        {
            errorMessage.text(message);
            errorMessage.show();
        }
        else 
        {
            const inputBox = $($(input).closest('.input-box'));
            inputBox.append("<div class='form-error-box temp-error-box'><div class='message'>" + message + "</div></div>");
        }

        
    
        $(input).on('keydown', function() {
            
            $(errorBoxSelector).hide();
            $(errorBoxSelector).text('');

            t.errors = [];

            $('input.red').removeClass('red');
            $(input).off('keydown');

            if(errorMessage.length <= 0) {
                $('.temp-error-box', $(input).closest('.input-box')).remove();
            }
        });
    }
}

class SingleInputValidation {

    constructor(input) {
        this.input = input;
    }

    invalidateInput(message) {

        if(this.input.hasClass('red')) { return; };
        
        this.input.addClass('red')
        this.input.focus();
      
        const inputBox = $(this.input.closest('.input-box'));
        inputBox.append("<div class='form-error-box temp-error-box'><div class='message'>" + message + "</div></div>");

        const thisInput = this.input;
        this.input.on('keydown', function() {

            thisInput.removeClass('red');
            thisInput.off('keydown');

            $('.temp-error-box', thisInput.closest('.input-box')).remove();
        }); 
    }

}

